module.exports = __webpack_public_path__ + "img/business-icon-09.6547853e.png";